import React from 'react';
import PropTypes from 'prop-types';

class PodcastOverviewComponent extends React.Component {

    handleDescriptionClick = () => {
        this.props.handleDescriptionClick(this.props.episode, this.props.index);
    };

    render() {
        const {name, img, longDesc} = this.props.episode
        return (
            <li className="episode-list-item">
                <button
                    onClick={() => this.handleDescriptionClick()}
                    className="item-link"
                >
                    <div className="image-hold">
                        <img src={img} alt="episode image" className="link-img"/>
                    </div>
                    <div className="content-hold">
                        <span className="link-desc">{name} - {longDesc}</span>
                    </div>
                </button>
            </li>
        );
    }
}

export default PodcastOverviewComponent;

PodcastOverviewComponent.propTypes = {
    id: PropTypes.string,
    logo: PropTypes.string,
    header: PropTypes.string,
    description: PropTypes.string,
    handlePlayClick: PropTypes.func,
    handleDescriptionClick: PropTypes.func
};



// WEBPACK FOOTER //
// src/client/components/common/podcasts/PodcastOverviewComponent.js